export default __webpack_public_path__ + "static/media/kea_logo.90db6344.png";